import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { UpcomingPastBookingContext } from "../Context/UpcomingPastBookingContext";


class UpcomingPastBookingInitStep extends StepFlow {
    get stepName() { return "UpcomingPastBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
    }

    async onExecute(): Promise<void> {
        console.log("Upcoming/Past Booking Initial Step Executed.....");
        const context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext")!
        if (context) {
            if (context.nextTo === "RetrieveBooking" && context.routeTo.includes("UpcomingPastBookingInit_Step")) {
                context.routeTo = [];
                //This will start retrieve booking flow
                this.next()
            } else {
                //This will start upcoming/past booking flow
                this.next();
            }
        } else {
            //This will start upcoming/past booking step
            this.next();
        }
    }
}

export const UpcomingPastBookingInitStepDeclaration = new StepDefinition({
    stepName: "UpcomingPastBookingInit_Step",
    stepClass: UpcomingPastBookingInitStep
});